import MicroModal from 'micromodal';

function handleOnShow(modal) {
  const iframe = modal.querySelector('iframe');
  const event = new CustomEvent('modalOpen', {
    cancelable: true,
    bubbles: false,
  });

  modal.dispatchEvent(event);

  if (!iframe || !iframe.hasAttribute('data-autoplay')) {
    return;
  }

  iframe.setAttribute('src', iframe.getAttribute('data-src'));
}

function handleOnClose(modal) {
  const iframe = modal.querySelector('iframe');
  const event = new CustomEvent('modalClose', {
    cancelable: true,
    bubbles: false,
  });

  modal.dispatchEvent(event);

  if (!iframe || !iframe.hasAttribute('data-autoplay')) {
    return;
  }

  iframe.setAttribute('src', '');
}

function videoModal() {
  MicroModal.init({
    awaitOpenAnimation: true,
    onShow: handleOnShow,
    onClose: handleOnClose,
  });
}

export function init() {
  videoModal();
}
